'use client';
import { useController, useFormContext } from 'react-hook-form';
import DatePicker, { DatePickerProps } from './DatePicker';

const FormDatePicker = ({ name, label, helperText, ...props }: DatePickerProps) => {
    const { control } = useFormContext();
    const {
        field: { onBlur, onChange, value, name: fieldName, ref: fieldRef, disabled },
        fieldState: { invalid, error }
    } = useController({
        name,
        control
    });

    return (
        <DatePicker
            label={label}
            ref={fieldRef}
            onBlur={onBlur}
            onChange={onChange}
            value={value}
            name={fieldName}
            isDisabled={disabled}
            {...props}
            isInvalid={invalid}
            // after the spread on purpose: a field that passes its own helper text used to hide
            // the validation message behind it, so a rejected date failed silently
            helperText={error?.message ?? helperText}
        />
    );
};

export { DatePicker };
export type { DatePickerProps };
export default FormDatePicker;
